<template>
  <div class="lbv-leak-list animated fadeIn roundedCard">
    <b-card>
      <div class="row">
        <div class="col-lg-12">
          <b-card class="dashboard-container">
            <div class="row">
              <div
                class="col-12 col-xl-3"
              >
                <div class="row">
                  <div
                    class="col-12 col-xl-2 dashboard-filter"
                  >
                    <label class="font-weight-bold">Tenant</label>
                  </div>
                  <div
                    class="col-12 col-xl-10"
                  >
                    <b-form-select
                      v-model="tenantSelection"
                      class="dashboard-filter-input"
                    >
                      <option :value="null">
                        All Tenants
                      </option>
                      <option
                        v-for="tenant in tenants"
                        v-bind="$attrs"
                        :key="tenant.id"
                        :value="{ id: tenant.id }"
                        @option="$emit('option', $event.target.value)"
                      >
                        {{ tenant.name }}
                      </option>
                    </b-form-select>
                  </div>
                </div>
              </div>
              <div
                class="col-12 col-xl-7"
              >
                <div class="row">
                  <div
                    class="col-12 col-xl-2 text-right dashboard-filter"
                  >
                    <label class="font-weight-bold">Time Period</label>
                  </div>
            
                  <div
                    class="col-12 col-xl-4"
                  >
                    <b-form-input
                      id="dateFrom"
                      v-model="dateFrom"
                      type="date"
                      class="dashboard-filter-input date-picker"
                      name="dateFrom"
                      placeholder="YYYY-MM-DD"
                    />
                  </div>
                  <div
                    class="col-12 col-xl-6"
                  >
                    <input
                      id="dateTo"
                      v-model="dateTo"
                      type="date"
                      class="dashboard-filter-input form-control date-picker"
                      name="dateTo"
                      placeholder="YYYY-MM-DD"
                    >
                  </div>
                </div>
              </div>
              <div
                class="col-12 col-xl-1"
              >
                <button
                  id="applyBtn"
                  type="submit"
                  class="btn btn-primary applyFilter pull-right"
                  :disabled="applyBtnDisabled"
                  @click.prevent="applyButtonClicked"
                >
                  Apply
                </button>
              </div>
            </div>
          </b-card>
        </div>
      </div>   
   
      <div class="animated fadeIn roundedCard">
        <!-- new dashboard -->
        <b-card>
          <div class="row">
            <div
              class="col-12 col-xl-3"
            >
              <div
                class="row"
              >
                <div
                  class="col"
                >
                  <div
                    class="card"
                    style="height:8rem;"
                  > 
                    <div
                      class="card-body align-items-center"
                    >
                      <h4 class="card-title-dashboard">
                        Total Shipped Devices
                      </h4>
                      <p
                        v-if="!isLoadingOrdersAndRegistrationsList"
                        class="card-text-dashboard-numbers text-center"
                      >
                        {{ ordersAndRegistrationsList[0]? ordersAndRegistrationsList[0].total_delivered : 0 }}
                      </p>
                      <div
                        v-if="isLoadingOrdersAndRegistrationsList"
                        class="card-text-spinner text-center"
                      >
                        <i
                          class="fa fa-spinner fa-spin"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div
                  class="col"
                >
                  <div
                    class="card"
                    style="height:8rem;"
                  > 
                    <div class="card-body align-items-center">
                      <h4 class="card-title-dashboard">
                        Total Registered Devices
                      </h4>
                      <p
                        v-if="!isLoadingOrdersAndRegistrationsList"
                        class="card-text-dashboard-numbers text-center"
                      >
                        {{ ordersAndRegistrationsList[0] ? ordersAndRegistrationsList[0].total_registered : 0 }}
                      </p>
                      <div
                        v-if="isLoadingOrdersAndRegistrationsList"
                        class="card-text-spinner text-center"
                      >
                        <i
                          class="fa fa-spinner fa-spin"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div
                  class="col-12 col-xl-6"
                >
                  <div
                    class="card"
                    style="height:7.75rem;"
                  > 
                    <div class="card-body align-items-center">
                      <h5 class="card-title-dashboard">
                        Post-Repair NPS
                      </h5>
                      <p
                        v-if="!isLoadingMarketingMetricsList"
                        class="card-text-dashboard-numbers text-center"
                      >
                        {{ marketingMetricsList[0] ? (marketingMetricsList[0].average_nps_score_percentage? 
                          marketingMetricsList[0].average_nps_score_percentage : 'N/A') : 'N/A' }}
                      </p>
                      <div
                        v-if="isLoadingMarketingMetricsList"
                        class="card-text-spinner text-center"
                      >
                        <i
                          class="fa fa-spinner fa-spin"
                        />
                      </div>
                    </div>
                  </div>
                </div>
          
                <div
                  class="col-12 col-xl-6"
                >
                  <div
                    class="card"
                    style="height:7.75rem;"
                  > 
                    <div class="card-body align-items-center">
                      <h5 class="card-title-dashboard">
                        Post-Repair CSAT
                      </h5>
                      <p
                        v-if="!isLoadingMarketingMetricsList"
                        class="card-text-dashboard-numbers text-center"
                      >
                        {{ marketingMetricsList[0] ? (marketingMetricsList[0].average_csat_percentage? 
                          marketingMetricsList[0].average_csat_percentage : 'N/A') : 'N/A' }}
                      </p>
                      <div
                        v-if="isLoadingMarketingMetricsList"
                        class="card-text-spinner text-center"
                      >
                        <i
                          class="fa fa-spinner fa-spin"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>  
            </div>      
            <div
              class="col-12 col-xl-7"
            >
              <div
                class="card"
              > 
                <div class="card-body dashboard-chart">
                  <div
                    v-if="!isLoadingMonthlyRegistrationsList"
                    class="chart-wrapper"
                  >
                    <BarComboChart
                      :cumulative-registered-devices="cumulativeRegisteredDevices"
                      :registered-devices="totalRegisteredDevices"
                      :categories="registeredDeviceCategories"
                    />
                  </div>
                  <div
                    v-if="isLoadingMonthlyRegistrationsList"
                    class="card-text-spinner text-center"
                  >
                    <i
                      class="fa fa-spinner fa-spin"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              class="col-12 col-xl-2"
            >
              <div
                class="card-ROI"
              >
                <div class="card-body align-items-center">
                  <h5 class="card-title-ROI text-center">
                    ROI Dashboard
                  </h5>
                  <p
                    v-if="lastUpdatedDate"
                    class="card-text-ROI-updated text-center"
                  >
                    Last updated: {{ lastUpdatedDate }}
                  </p>
                  <p class="card-text-ROI">
                    Average cost to claim
                  </p>
                  <div
                    v-if="isLoadingDamageCausingRepairs && isLoadingWorkOrderClaimSavings"
                    class="card-text-roi-spinner text-center"
                  >
                    <i
                      class="fa fa-spinner fa-spin"
                    />
                  </div>
                  <p
                    v-if="!isLoadingDamageCausingRepairs && !isLoadingWorkOrderClaimSavings"
                    class="card-text-ROI-value text-center"
                  >
                    {{ averageCostToClaim() | currency(currencyCode) }}
                  </p>
                  <p class="card-text-ROI">
                    Number of claims saved
                  </p>
                  <div
                    v-if="isLoadingDamageCausingRepairs"
                    class="card-text-roi-spinner text-center"
                  >
                    <i
                      class="fa fa-spinner fa-spin"
                    />
                  </div>
                  <p
                    v-if="!isLoadingDamageCausingRepairs"
                    class="card-text-ROI-value text-center"
                  >
                    {{ damageCausingRepairsFixed }}
                  </p>
                  <p class="card-text-ROI">
                    Estimated Claims Savings
                  </p>
                  <div
                    v-if="isLoadingWorkOrderClaimSavings"
                    class="card-text-roi-spinner text-center"
                  >
                    <i
                      class="fa fa-spinner fa-spin"
                    />
                  </div>
                  <p
                    v-if="!isLoadingWorkOrderClaimSavings"
                    class="card-text-ROI-value text-center"
                  >
                    {{ estimatedClaimsSavings() | currency(currencyCode) }}
                  </p>
                  <p class="card-text-ROI">
                    Cost of Programme
                  </p>
                  <div
                    v-if="isLoadingCostOfProgramme"
                    class="card-text-roi-spinner text-center"
                  >
                    <i
                      class="fa fa-spinner fa-spin"
                    />
                  </div>
                  <p
                    v-if="!isLoadingCostOfProgramme"
                    class="card-text-ROI-value text-center"
                  >
                    {{ programme() | currency(currencyCode) }}
                  </p>
                  <p class="card-text-ROI">
                    Return on Investment
                  </p>
                  <div
                    v-if="isLoadingCostOfProgramme && isLoadingWorkOrderClaimSavings"
                    class="card-text-roi-spinner text-center"
                  >
                    <i
                      class="fa fa-spinner fa-spin"
                    />
                  </div>
                  <p
                    v-if="!isLoadingCostOfProgramme && !isLoadingWorkOrderClaimSavings"
                    class="card-text-ROI-value text-center"
                  >
                    {{ roi() }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <!-- spacer -->&nbsp;
            </div>
          </div>
          <div class="row">
            <div
              class="col-12 col-xl-3"
            >
              <div
                class="card"
              > 
                <div class="card-body dashboard-feedback">
                  <h4 class="card-title-dashboard">
                    Customer Feedback
                  </h4>
                  <div v-if="!isLoadingCustomerFeedbackList">
                    <div
                      v-for="item in customerFeedbackList"
                      :key="item.leakbot_id"
                    >
                      <p class="card-text-dashboard">
                        {{ item.created_on | moment }} - {{ item.leakbot_id }}
                      </p>
                      <p>
                        {{ item.customer_feedback }}
                      </p>
                    </div>
                  </div>
                  <div
                    v-if="isLoadingCustomerFeedbackList"
                    class="card-text-spinner text-center"
                  >
                    <i
                      class="fa fa-spinner fa-spin"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              class="col-12 col-xl-7"
            >
              <div
                class="row"
              >
                <div
                  class="col-12 col-xl-4"
                >
                  <div
                    class="card"
                    style="height:8rem;"
                  > 
                    <div class="card-body align-items-center">
                      <h5 class="card-title-dashboard">
                        Leak Alerts
                      </h5>
                      <p
                        v-if="!isLoadingLowLeakAlerts"
                        class="card-text-dashboard-numbers text-center"
                      >
                        {{ lowLeakAlerts.total_lowleak_alerts }}
                      </p>
                      <div
                        v-if="isLoadingLowLeakAlerts"
                        class="card-text-spinner text-center"
                      >
                        <i
                          class="fa fa-spinner fa-spin"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="col-12 col-xl-4"
                >
                  <div
                    class="card"
                    style="height:8rem;"
                  > 
                    <div class="card-body align-items-center">
                      <h5 class="card-title-dashboard">
                        Repair Visits
                      </h5>
                      <p
                        v-if="!isLoadingRepairs"
                        class="card-text-dashboard-numbers text-center"
                      >
                        {{ repairs.total_repairs }}
                      </p>
                      <div
                        v-if="isLoadingRepairs"
                        class="card-text-spinner text-center"
                      >
                        <i
                          class="fa fa-spinner fa-spin"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="col-12 col-xl-4"
                >
                  <div
                    class="card"
                    style="height:8rem;"
                  > 
                    <div class="card-body align-items-center">
                      <h5 class="card-title-dashboard">
                        Number of Claims Saved
                      </h5>
                      <p
                        v-if="!isLoadingDamageCausingRepairs"
                        class="card-text-dashboard-numbers text-center"
                      >
                        {{ damageCausingRepairs }}
                      </p>
                      <p class="text-center">
                        <span class="badge text-bg-secondary">Of Repair Visits: {{ percentageClaimsInRepairVisits() }}</span>
                      </p>
                      <div
                        v-if="isLoadingDamageCausingRepairs"
                        class="card-text-spinner text-center"
                      >
                        <i
                          class="fa fa-spinner fa-spin"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div
                  class="col-12"
                >
                  <div
                    class="card"
                  >
                    <div class="card-body dashboard-chart">
                      <div
                        v-if="!isLoadingLeakCategoriesList"
                        class="chart-wrapper"
                      >
                        <PieChart
                          :leaks-fixed="totalRepairs"
                          :leaks-labels="leakCategories"
                        />
                      </div>
                      <div
                        v-if="isLoadingLeakCategoriesList"
                        class="card-text-spinner text-center"
                      >
                        <i
                          class="fa fa-spinner fa-spin"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-card>
      <!-- end new dashboard -->
      </div>
    </b-card>
  </div>
</template>

<script>
import moment from 'moment';
import dashboardMixin from "@/mixins/dashboardMixin";
import BarComboChart from "@/views/charts/apex/BarCombo";
import PieChart from "@/views/charts/apex/Pie";

export default {
  name: "Dashboard",
  components: {
    BarComboChart,
    PieChart
  },
  mixins: [dashboardMixin],
  data() {
    return {
      tenantSelection: null,
      dateFrom: this.getCurrentYearDate(true),
      dateTo: this.getCurrentYearDate(false)
    };
  },
  computed: {
    lastUpdatedDate() {
      if (!this.lastInvoiceMonth) return null;
      return moment(this.lastInvoiceMonth).endOf('month').format('DD MMM YYYY');
    }
  },
  methods: {
    getCurrentYearDate(startOfTheYear) {
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      let date = new Date(currentYear, 0, 1); // January 1st of the current year

      if(!startOfTheYear) {
        date = new Date(currentYear, 11, 31); // December 31st of the current year
    }

      // Return formatted date (YYYY-MM-DD)
      return this.formatDate(date); // Use startOfYear or endOfYear as required
    },

    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Ensure two digits
      const day = String(date.getDate()).padStart(2, '0'); // Ensure two digits
      return `${year}-${month}-${day}`;
    }
  }
};
</script>
<style scoped>
  .roundedCard {
    font-family: 'Nunito Sans', 'arial', 'serif' !important;
  }
  .card-ROI {
    background-color: #0b1a51;
    border-radius: 20px;
  }
  .card-title-dashboard {
    font-size: 1vw;
    font-family: 'Nunito Sans', 'arial', 'serif' !important;
  }
  .card-title-dashboard-small {
    font-size: .75vw;
  }
  .card-title-ROI {
    font-size: 1rem;
    color: #23d3c5;
    font-family: 'Nunito Sans', 'arial', 'serif' !important;
  }
  .card-text-spinner {
    font-size: 2rem;
    font-family: 'Nunito Sans', 'arial', 'serif' !important;
  }
  .card-text-roi-spinner {
    font-size: 2rem;
    color: white;
    font-family: 'Nunito Sans', 'arial', 'serif' !important;
  }
  .card-text-dashboard .card-text-dashboard-numbers {
    font-size: 1rem;
    font-weight: bold;
    font-family: 'Nunito Sans', 'arial', 'serif' !important;
  }
  .card-text-dashboard-numbers {
    font-size: 1.75rem;
    margin-bottom: 0;
  }
  .card-text-author {
    font-size: 1rem;
    font-family: 'Nunito Sans', 'arial', 'serif' !important;
  }
  .card-text-ROI {
    font-size: .75rem;
    color: #23d3c5;
    font-weight: lighter;
  }
  .card-text-ROI-value {
    font-size: 1.25rem;
    color: white;
    font-family: 'Nunito Sans', 'arial', 'serif' !important;
    font-weight: bold;
  }
  .card-text-ROI-updated {
    font-size: .7rem;
    color: #23d3c5;
    font-family: 'Nunito Sans', 'arial', 'serif' !important;
    margin-bottom: 0.5rem;
  }
  .badge {
    color: #333;
    background-color: #f0f3f5;
    border-radius: 20px;
    padding: .5rem;
    font-size: .75vw;
    font-family: 'Nunito Sans', 'arial', 'serif' !important;
  }
  .dashboard-container {
    background-color: #f0f3f5;
    font-family: 'Nunito Sans', 'arial', 'serif' !important;
  }
  .dashboard-filter {
    line-height: 40px;
    font-family: 'Nunito Sans', 'arial', 'serif' !important;
  }
  .dashboard-filter-input {
    width: 200px;
    border-radius: 8px;
    font-family: 'Nunito Sans', 'arial', 'serif' !important;
  }
  .dashboard-feedback {
    max-height: 571px;
    overflow-y: scroll;
    font-family: 'Nunito Sans', 'arial', 'serif' !important;
  }
  .dashboard-chart {
    margin-bottom: -22px;
  }
</style>